import * as React from "react";
import { Control, Errors } from "react-redux-form";
import * as DTOS from "../../../../FeralScan.dtos";
import * as SurveyActionCreators from "../../../../actions/survey.actions";
import { mapProps, updateOn, showErrors } from "./ReactReduxFormSettings";
import MapLocation from "./MapLocation";
import { required } from "../../../Common/validators";
import ValidationMessage from "./ValidationMessage";


export type MapLocationControlProps = {
    attachment: any;
    className?: string;
    description: string;
    mandatory: boolean;
    mapMarkerComponent: any;
    model: string;
    name: string;
    questionIndex: number;
    survey: DTOS.Survey;
};

export type MapLocationControlActions = {
    setQuestionValue: typeof SurveyActionCreators.setQuestionValueRequest
};

export type MapLocationControlPropsAndActions = MapLocationControlProps & MapLocationControlActions;

export type MapLocationControlState = {
    marker: DTOS.Plot,
    showMarker: boolean
};

class MapLocationControl extends React.PureComponent<MapLocationControlPropsAndActions, MapLocationControlState> {
    constructor(props: MapLocationControlPropsAndActions) {
        super(props);

        this.state = {
            marker: undefined,
            showMarker: false
        }
        
        this.onMapClicked = this.onMapClicked.bind(this);
    }

    onMapClicked(latitude: number, longitude: number) {
        this.setState({
            marker: {
                active: false,
                email: "",
                endDate: "",
                fullName: "",
                id: 0,
                latitude: latitude,
                longitude: longitude,
                name: "",
                obsolete: false,
                plotEvents: [],
                private: false,
                registered: false,
                startDate: "",
                state: "",
                userId: 0,
                newestPlotEventDate: "",
                userNewestPlotEventDate: "",
                userPlotEventsCount: 0,
                totalPlotEventCount: 0,
                userTotalSightingsCount: 0,
                userOrderMonitored: undefined,
                plotStatus: undefined,
                nearestSuburb: undefined,
                waterBody: undefined,
                apcCode: undefined,
                createdDate: undefined,
                plotPhoto: undefined,
            },
            showMarker: true
        });
    }

    getLat(coords: string) {
        if (coords) {
            try {
                let split: string[] = coords.split(',');

                if (split.length == 2) {
                    return parseFloat(split[0]);
                }
            }
            catch (e) {
                //there was an error
                console.log(e);
            }
        }

        return undefined;
    }

    getLong(coords: string) {
        if (coords) {
            try {
                let split: string[] = coords.split(',');

                if (split.length == 2) {
                    return parseFloat(split[1]);
                }
            }
            catch (e) {
                //there was an error
                console.log(e);
            }
        }

        return undefined;
    }

    render() {
        return (
            <div className={this.props.className}>
                <Control
                    model={this.props.model}
                    component={MapLocation}
                    updateOn={updateOn}
                    mapProps={mapProps}
                    controlProps={{
                        lng: this.getLong(this.props.survey.questions[this.props.questionIndex].value),
                        lat: this.getLat(this.props.survey.questions[this.props.questionIndex].value),
                        showMarker: this.state.showMarker,
                        mapMarkerComponent: this.props.mapMarkerComponent,
                        marker: this.state.marker,
                        toggleNewMarkerPopup: undefined,
                        onMapClicked: this.onMapClicked
                    }}
                    validators={{
                        required: this.props.mandatory ? required : () => { return true; }
                    }}
                />
                <Errors
                    className="invalid-feedback d-block"
                    model={this.props.model}
                    messages={{
                        required: "Please select a location"
                    }}
                    show={showErrors}
                    component={ValidationMessage}
                />
            </div>
        )
    }
}

export default MapLocationControl